import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/user-groups';
import { UserGroup } from '@rootCommon/types/user-group';
import { ResultState } from '@rootCommon/types/common';

type Action = ActionType<typeof actions>;
export type UserGroupState = ResultState<UserGroup | null>;

const initState: UserGroupState = {
  data: null,
  loading: false,
  error: null,
};

export const userGroupReducer = (state = initState, action: Action): UserGroupState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchUserGroup.request):
      return { ...state, loading: true, error: null };
    case getType(actions.fetchUserGroup.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchUserGroup.failure):
      return { ...state, loading: false, error: action.payload };

      // create
    case getType(actions.createUserGroup.request):
      return { ...state, loading: true, error: null };
    case getType(actions.createUserGroup.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.createUserGroup.failure):
      return { ...state, loading: false, error: action.payload };

      // create modal
    case getType(actions.createUserGroupModal.request):
      return { ...state, loading: true, error: null };
    case getType(actions.createUserGroupModal.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.createUserGroupModal.failure):
      return { ...state, loading: false, error: action.payload };

      // update
    case getType(actions.updateUserGroup.request):
      return { ...state, loading: true, error: null };
    case getType(actions.updateUserGroup.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.updateUserGroup.failure):
      return { ...state, loading: false, error: action.payload };

      // delete
    case getType(actions.deleteUserGroup.request):
      return { ...state, loading: true, error: null };
    case getType(actions.deleteUserGroup.success):
      return { ...state, loading: false, data: null };
    case getType(actions.deleteUserGroup.failure):
      return { ...state, loading: false, error: action.payload };

      // default
    default:
      return state;
  }
};

export default userGroupReducer;
